// Minimal formatter for AI replies: "# " headings, **bold** and *italic*; keeps line breaks.
const INLINE = /(\*\*[^*]+\*\*|\*[^*\n]+\*)/g;

function Inline({ text }) {
  return text.split(INLINE).map((part, i) => {
    const key = `${i}-${part.slice(0, 12)}`;
    if (part.startsWith("**") && part.endsWith("**") && part.length > 4) return <strong key={key} className="font-bold text-white">{part.slice(2, -2)}</strong>;
    if (part.startsWith("*") && part.endsWith("*") && part.length > 2) return <em key={key}>{part.slice(1, -1)}</em>;
    return part;
  });
}

export default function RichText({ text, className = "" }) {
  const lines = (text || "").split("\n");
  return (
    <div className={`whitespace-pre-wrap font-sans leading-relaxed ${className}`}>
      {lines.map((line, i) => {
        const key = `${i}-${line.slice(0, 16)}`;
        const h = line.match(/^#{1,4}\s+(.*)$/);
        if (h) return <p key={key} className="font-display font-bold uppercase tracking-tight text-white text-base mt-1"><Inline text={h[1]} /></p>;
        if (/^-{3,}$/.test(line.trim())) return <hr key={key} className="border-white/10 my-2" />;
        return <span key={key}><Inline text={line} />{i < lines.length - 1 ? "\n" : ""}</span>;
      })}
    </div>
  );
}
